const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F63AD"
    },
    d: "M495.304,512H16.696C7.467,512,0,504.533,0,495.304c0-9.228,7.467-16.696,16.696-16.696h478.609 c9.228,0,16.696,7.467,16.696,16.696C512,504.533,504.533,512,495.304,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004999"
    },
    d: "M495.304,478.609H256V512h239.304c9.228,0,16.696-7.467,16.696-16.696 C512,486.076,504.533,478.609,495.304,478.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M495.304,0H395.13c-9.228,0-16.696,7.467-16.696,16.696v411.826c0,9.228,7.467,16.696,16.696,16.696 h100.174c9.228,0,16.696-7.467,16.696-16.696V16.696C512,7.467,504.533,0,495.304,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA00"
    },
    d: "M512,428.522V16.696C512,7.467,504.533,0,495.304,0h-50.087v445.217h50.087 C504.533,445.217,512,437.75,512,428.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BBFF"
    },
    d: "M205.913,445.217h100.174c9.228,0,16.696-7.467,16.696-16.696v-267.13 c0-9.228-7.467-16.696-16.696-16.696H205.913c-9.228,0-16.696,7.467-16.696,16.696v267.13 C189.217,437.75,196.685,445.217,205.913,445.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9FD9"
    },
    d: "M322.783,428.522v-267.13c0-9.228-7.467-16.696-16.696-16.696H256v300.522h50.087 C315.315,445.217,322.783,437.75,322.783,428.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B26"
    },
    d: "M16.696,445.217H116.87c9.228,0,16.696-7.467,16.696-16.696V294.957 c0-9.228-7.467-16.696-16.696-16.696H16.696C7.467,278.261,0,285.728,0,294.957v133.565C0,437.75,7.467,445.217,16.696,445.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D93F21"
    },
    d: "M133.565,428.522V294.957c0-9.228-7.467-16.696-16.696-16.696H66.783v166.957h50.087 C126.098,445.217,133.565,437.75,133.565,428.522z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.1a700684a7b76151b12e6949a0a379f7.svg";
export { ForwardRef as ReactComponent };